import {Base} from "./Base";
import {Model} from "./Model";
import { AppointmentModel, TodoModel, ContactModel } from "../CommunicicationCycle/CommunicationCycle";

export class Collection extends Base {
    private refHolder: Array<string> = [];
    public items: Array<any> = [];
    public length:number = 0;
    private whereHolder: {[key: string]: object} | null = null
    private index = 0;
    public letters:Array<String> = [];
    constructor(data = null, modelInstance = null, keyName = null) {
        super();
        
        if(data) {
            
            if(data instanceof Model) {
                this.set(data);
                //if(keyName == 'parentKeys') 

            } else if(data instanceof Array) {
                let self = this;
                //if(keyName == 'parentKeys') 
                
                data.forEach( function(item) {
                    let model:Model;
                    if(modelInstance) {
                        model = new modelInstance(item);
                    }
                    else if(item instanceof Model) {
                        model = item;
                    } else {
                        if(item && typeof item?.modelName == 'string' && item?.modelName != "" && item.modelName != 'undefined') {
                            switch(item?.modelName) {
                                case "TodoModel":
                                    model = new TodoModel(item);
                                    break;
                                case "ContactModel":
                                    model = new ContactModel(item);
                                    break;
                                case "AppointmentModel":
                                    model = new AppointmentModel(item);
                                    break;
                                    
                            }
                        }
                        if(modelInstance) {
                            model = new modelInstance(item);
                        } else if(!model) {
                            if(item instanceof Object) {
                                model = new Model(item);
                            } else {
                                model = item;
                            }
                        }
                    }
                    self.refHolder.push(model.uid); 
                    self.items.push(model);
// console.debug(model);
//                     let firstLetterName = model['name'].substring(0,1);
//                     if(this.letters[firstLetterName] == undefined) {
//                         this.letters[firstLetterName] = [];
//                     }
//                     this.letters[firstLetterName].push(model);

                });
            } else if(data instanceof Object) {
                let self = this;
                Object.keys(data).map((objKey:any) => {
                    let model:Model;
                    if(modelInstance) {
                        model = new modelInstance(data[objKey]);
                    }
                    
                    if(data[objKey] instanceof Model) {
                        model = data[objKey];
                    } else {
                        if(data instanceof Array) {
                            //model = new Model();
                            model = new Model(data[objKey]);
                        } else if(!model) {
                            model = new Model(data[objKey]);
                        }
                    }
                        model.uid = objKey;
                    self.refHolder.push(objKey); 
                    self.items.push(model);
                });
            }
            this.length = this.items.length;
        }
    }
    
    public add=(model)=> {
        this.items.push(model);
        this.refHolder.push(model.uid);
        this.length += 1;
    }
    
    public first=() => {
        this.index = 0;
        let first = this.items[this.index];
        return first;
    }

    public next=() => {
        this.index += 1;
        if(this.index > (this.items.length - 1)) {
            this.index = (this.items.length - 1);
        }
        let first = this.items[this.index];
        return first;
    }

    public last=() => {
        this.index = (this.items.length - 1);
        let last = this.items[ this.index ];
        return last;
    }
    
    public getByIndex=(idx:number) => {
        let last = this.items[ idx ];
        return last;
    }
    
    
    public map=(func:any) => {
        let retVal;
        retVal = (this.get().map((item, index) => {
            return func(item, index);
        }));
        return retVal;
    }
    public for=(func:any) => {
    for (const element of this.get()) {
        func(element);
    }
    }
    public forEach=(func:any) => {
            let retVal;
            retVal = ((this.get()).each((item) => {
                return func(item);
            }));
            return retVal;
        }
    public wherenot=(column:string, val:any) => {
        if(!this.whereHolder) {
            this.whereHolder = {};
        }
        this.whereHolder[column] = {type: '!=', value:val};
        return this;
    }

    public where=(column:string, val:any) => {
        if(!this.whereHolder) {
            this.whereHolder = {};
        }
        this.whereHolder[column] = {type: '==', value:val};
        return this;
    }

    public whereContains=(column:string, val:any) => {
        if(!this.whereHolder) {
            this.whereHolder = {};
        }
        this.whereHolder[column] = {type: 'like', value: val+""};
        return this;
    }

    public resetWhere=() => {
        this.whereHolder = {};
        return this;
    }

    public has(keyName) {
        return ( (this.refHolder.includes(keyName)) ? true : false)
        }
    
    public findOne(key, keyName = "ref") {
        return this.findChildByKey(key, keyName);
        }
    public merge(...data) {
        
        let newItems = this.items;
        data.forEach((data, index) => {
            newItems = newItems.concat( data.items );    
        })
        
        let    ret = new Collection(this.sort(newItems));
        return ret;
    }
    
    public sort(items = null, keys= null) {
        let returnItems = true;
        if(items === null) {
            items = this.items;
            returnItems = false;
        }
        console.debug( "sort itemes 1", items )
        items.sort((a,b) => {
            let check1 = null;
            let check2 = null;
            if(a.hasOwnProperty('name')){
                check1 = a?.name.toUpperCase();
            } else if(a.hasOwnProperty('fullName')){
                check1 = a.fullName.toUpperCase();
            }
            
            if(b.hasOwnProperty('name')){
                check2 = b?.name.toUpperCase();
            } else if(b.hasOwnProperty('fullName')){
                check2 = b.fullName.toUpperCase();
            }
            
            
            return (check1 > check2) ? 1 : ((check2 > check1) ? -1 : 0)
        })
        
        if(!returnItems) {
            this.items = items;
            this.reindex();
            return this;
        }
        
                
        return items;
    }
    
    
    public findChildByKey(key, keyName = "ref", withParent = false) {
        let selected = null;
        if(typeof key == 'string') {
            key = key.trim();
        }
        this.items.forEach( function(item) {
            let keyChild;
            if(keyName.includes(".")) {
                let keyNameArray = keyName.split('.');
                let tmpVal = item;
                keyNameArray.forEach( (val, index) => {
                    tmpVal = tmpVal[val];
                });
                keyChild = tmpVal;
            } else {
                keyChild = item[keyName];
            }
                
            if( typeof keyChild == 'string' ) {
                keyChild = keyChild.trim();
            }
            if(keyChild == key) {
                selected = item;
                if(withParent) {
                    //selected.parent = item.getData(['uid', 'key', 'name', 'type'], true);    
                }
                     
            } else if( item.children ) {
                let hasFound = item.children.findChildByKey(key, keyName);
                if(hasFound) {
                    selected = hasFound;
                    if(withParent) {
                        selected.parent = item.getData(['uid', 'key', 'name', 'type'], true);    
                    }
                    
                }
            }
        });
        
        return selected;
    }

    public get=(asCollection:boolean = false, singleItem:boolean = false) => {
        let ret:any = this.items;
        let self = this;
        if(self.whereHolder && self.length > 0) {
            let whereKeys = Object.keys(self.whereHolder);
            if(whereKeys && whereKeys.length > 0) {
        ret = this.items.filter( function(item, idx, col) {
            let passedFilter = false;
            
            Object.keys(self.whereHolder).forEach( function(keyName, idx2) {
                if(item.hasOwnProperty(keyName)) {
                    let type = self.whereHolder[keyName]['type'];
                    let val = self.whereHolder[keyName]['value'];

                    if(idx2 > 0 && passedFilter === false) {
                        return passedFilter;
                    }

                    switch( typeof item[keyName] ) {
                        case 'string':
                                if(type == '==' && item[keyName].trim() == val.trim()) {
                                    passedFilter = true;
                                } else if(type == '!=' && item[keyName].trim() != val.trim()) {
                                    passedFilter = true;
                                } else if(type == 'like' && item[keyName].includes(val.trim())) {
                                        passedFilter = true;                                    
                                } else {
                                    passedFilter = false;
                                }
                            break;
                        case 'number':
                            if(type == '==' &&  Number(item[keyName]) == Number(val) ) {
                                passedFilter = true;
                            } else if(type == '!=' &&  Number(item[keyName]) != Number(val) ) {
                                passedFilter = true;
                            } else {
                                passedFilter = false;
                            }
                            break;    
                        case 'boolean':
                            if(type == '==' &&  (item[keyName]) == (val) ) {
                                passedFilter = true;
                            } else if(type == '!=' &&  (item[keyName]) != (val) ) {
                                passedFilter = true;
                            } else {
                                passedFilter = false;
                            }
                            break;    

                    }
//                    
                    
                }
            })
           return passedFilter; 
        });
        }
        self.whereHolder = null;
        }
        if(asCollection) {
            ret = new Collection(ret);
        }
        if(singleItem) {
            if(ret instanceof Collection) {
                ret = ret.first();
            } else {
                ret = ret[0];
            }
        }
        return (ret);
    }

    public set=(data) => {
        this.refHolder.push(data.uid);
        this.items.push(data);
        this.length = this.items.length;
        return this.items;
    }

    public update=(idx, data) => {
        this.items[idx] = (data);
        this.refHolder[data.uid] = idx;
        return this.items;
    }

    public delete=(uid:any) => {
        let index = this.refHolder.indexOf(uid);
        if(index >= 0) {
            let p = this.items.splice(index,1);
            this.refHolder.splice(index,1);
        }
        this.length = this.items.length;
        let ret = new Collection(this.items);
        return ret;
    }
    
    public getIndexForKey(key, keyName = 'uid') {
        let returnVal;
        
         this.items.forEach( function(item, index) {
            
            if(item[keyName] == key) {
                returnVal = index;
                ;
                return returnVal;
            }
        });
        return returnVal;
    }
    private reindex() {
        let refHolder = [];
        this.items.forEach( function(item, index) {
            refHolder[item.uid]            = index;
        });
        this.refHolder = refHolder;
    }
    
    public toJSON() {
        return JSON.stringify(this.items);
    }
    
    public getSelectedItems(keys, collectionFields = null, level = 0, retData = null, keyName = 'uid') {
        let retVal = retData;
        if(!retVal) {
            retVal = [];
        }
        if(typeof keys == 'string') {
            let keyArray = keys.split('.');
            let selectedKey = keyArray[level];
            let selectedItem = this.findChildByKey(selectedKey, keyName, true);
            if(!selectedItem) {
                if(typeof collectionFields == 'string' && this[collectionFields] && this[collectionFields] instanceof Collection) {
                    this[collectionFields].getSelectedItems(keys, collectionFields, level, retVal, keyName);
                }
            }
            if(selectedItem) {
                retVal.push(selectedItem.getData(['uid', 'key', 'name', 'parent'], true));
                if(typeof collectionFields == 'string' && selectedItem[collectionFields] && selectedItem[collectionFields] instanceof Collection) {
                    selectedItem[collectionFields].getSelectedItems(keys, collectionFields, level+1, retVal, keyName);
                }
                                
            }
        }
        return retVal;
    }
    public getChanges() {
        let retVal = [];
        this.items.forEach( function(item) {
            let itemChanges = Object.values(item.changes);
            if(item instanceof Model && 
                Array.isArray(itemChanges) &&
                itemChanges.length > 0) {
                retVal.push(item.getChanges());
            }
        });
        return retVal;
    }
    public getData(fields = null, asCollection = false, asModel = false) {
        let retVal:any = [];

        if(asCollection) {
            retVal = new Collection();
        }
        this.items.forEach( function(item) {
            if(item instanceof Model) {
            if(asCollection) {
                retVal.set( item.getData(fields, asModel) )
            } else {
                retVal.push( item.getData(fields, asModel) )
            }
            } else {
                retVal.push( item );
            }
        });

        
        return retVal;
    }

    public parseJSON(data) {
        
    }
    
}